module.exports = __webpack_public_path__ + "static/img/endlogo.9eee1291.png";